import React, { useState, useEffect } from 'react';
import '../css/ResetPassword.css';
import logoImg from '../public/logoQueruCume.png';
import { supabase } from '../config/supabase.js';
import { useNavigate } from 'react-router-dom';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Aguarda o Supabase processar a URL automaticamente
    const timer = setTimeout(async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        // Redireciona para tela de expirado se não houver sessão
        navigate('/reset-expired', { replace: true });
        return;
      }
      
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    if (password !== confirmPassword) {
      setError('As senhas não conferem.');
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await supabase.auth.updateUser({
        password: password
      });

      if (updateError) throw updateError;

      setSuccess(true);
      setTimeout(() => {
        navigate('/reset-sucess');
      }, 2000);
    } catch (err) {
      setError(err.message || 'Erro ao redefinir senha. Tente novamente.');
      setLoading(false);
    }
  };

  const wrapperStyle = {
    background: '#2d2d2d',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
  };

  return (
    <div className="reset-wrapper" style={wrapperStyle}>
      <div className="card-container">
        <img src={logoImg} alt="logo" className="logo-above" />
        <form className="reset-card" onSubmit={handleSubmit}>
          <h2 className="titulo">Redefinir senha</h2>

          {loading && !error && (
            <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>
              Verificando link...
            </p>
          )}

          {!loading && !success && (
            <>
              <label htmlFor="password">Nova senha</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite uma nova senha (mín. 8 caracteres)"
                required
                disabled={loading}
              />

              <label htmlFor="confirmPassword">Confirme a nova senha</label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Repita a nova senha"
                required
                disabled={loading}
              />

              <button type="submit" className="primary" disabled={loading}>
                {loading ? 'Processando...' : 'Redefinir senha'}
              </button>
            </>
          )}

          {success && (
            <div style={{
              color: '#00ff99',
              textAlign: 'center',
              padding: '20px',
              fontSize: '16px'
            }}>
              Senha redefinida com sucesso! Redirecionando...
            </div>
          )}

          {error && <div className="error">{error}</div>}
        </form>
      </div>
    </div>
  );
}

